<template lang="pug">
#product-list.flex-grow-1
  .body.w-100.h-100
    ShareHeader(
      ref="shareHeader"
      @openSideBar="$emit('openSideBar')"
      @notify="notify"
      @preview="preview"
    )
    .header
      .guide-info.d-flex.justify-content-between.mb-4
        .d-flex.flex-column.justify-content-center
          .text-primary 小撇步：<br>幫每樣商品寫下賣家的推薦原因，可以增加購買率喔！
        img(src="@/assets/images/ProductListBanner.svg")
      h4.mb-0 商品設定
    .wrapper
      .row.mb-3(v-show="currentPageSupplies.length < 40")
        .col-12
          router-link.btn.btn-primary.btn-block(
            :to="{ name: 'ProductSelection', params: { fromPageID: selectedPage._id } }"
          ) 新增商品
      .filter.mb-4
        .row
          .col-12
            CustomDropdown(
              placeholder="排序"
              :options="sortingOptions"
              @select="selectSortingOptions"
            )
      .sku-list.block.bg-white(v-if="currentPageSupplies.length")
        .d-none.d-md-flex.mb-3
          .sku-description-title.flex-shrink-0.mr-3.mr-md-4 商品名稱
          .row.flex-grow-1
            .col-9
              .row
                .col-7
                .col-5 價錢
            .col-3
              .pl-4 操作
        .sku-item.pointer-cursor(
          v-for="sku in pagingDisplaySupplies"
          :key="sku.commodity._id"
          @click="showSKUModal(sku)"
        )
          .d-flex
            .sku-image-wrapper.flex-shrink-0.mr-3.mr-md-4
              .sku-image.position-relative.overflow-hidden
                img.position-absolute.w-100(
                  :src="sku.commodity.imageUrls.length ? sku.commodity.imageUrls[0] : require('@/assets/images/empty-product.png')"
                )
                .sku-tv.position-absolute.rounded-circle.bg-primary(
                  v-show="sku.youtubeUrl"
                )
                  icon(
                    icon="video"
                    stroke="#fff"
                    :width="16"
                    :height="16"
                  )
                .sku-description.position-absolute.w-100(v-show="sku.comment")
                  .d-flex
                    icon(icon="volume" stroke="#fff")
                    span.text-white.d-inline-block.overflow-ellipsis {{ sku.comment }}
            .row.flex-grow-1
              .col-12.col-md-9
                .row.align-items-center
                  .col-12.col-md-7.mb-3.mb-md-0
                    .group-buy-badge(v-show="sku.allowGroupBuying") 團購任務
                    .font-weight-bold.mb-1 {{ $t(`__${sku.commodity.brand}`) }}
                    .sku-name {{ sku.commodity.name }}
                  .col-12.col-md-5
                    div
                      span.price ${{ sku.commodity.variants[0].sellingPrice | numberFormat }}
                      span.sharing-profit.border.border-dark.px-2.py-1.ml-2 分潤 ${{ sku.commodity.variants[0].sellerProfit | numberFormat }}
              .col-md-3.d-none.d-md-flex.align-items-center
                button.btn.btn-outline-primary.border-0(type="button") 編輯
      .row.mt-5(v-else)
        .offset-2.col-8.offset-md-4.col-md-4.offset-lg-5.col-lg-2
          img.w-100(src="@/assets/images/empty-button.svg")
          h5.text-center.mt-3 目前商品設定是空的喔！
      Pagination(
        :totalPage="Math.ceil(displaySupplies.length / 15)"
        @jumpTo="jumpTo"
      )
      .text-center.text-light.my-2 {{ displaySupplies.length | numberFormat }} 件商品
  ManageSKUModal(:sku="sku" @selectSKU="selectSKU" @updateSKU="updateSKU")
  PreviewModal(
    :page="selectedPage"
    :productList="currentPageSupplies"
    :hideSaveBtn="true"
    :tvList="currentPageTVs"
  )
  MissionMenu(ref="MissionMenu" v-if="canSell")
</template>

<script>
import ShareHeader from '@/components/ShareHeader.vue';
import Icon from '@/components/Icon.vue';
import CustomDropdown from '@/components/sku/CustomDropdown.vue';
import ManageSKUModal from '@/components/sku/modal/ManageSKUModal.vue';
import FilterSKUModal from '@/components/sku/modal/FilterSKUModal.vue';
import PreviewModal from '@/components/setting/modal/PreviewModal.vue';
import Pagination from '@/components/Pagination.vue';
import MissionMenu from '@/components/MissionMenu';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ProductList',
  components: {
    ShareHeader,
    Icon,
    CustomDropdown,
    ManageSKUModal,
    PreviewModal,
    FilterSKUModal,
    Pagination,
    MissionMenu,
  },
  data() {
    return {
      sku: {},
      responseMessage: '',
      currentPage: 0,
      selectedSuppliesSortingOption: '',
    };
  },
  computed: {
    ...mapState('sku', [
      'supplies',
      'sortingOptions',
    ]),
    ...mapGetters('sku', [
      'currentPageSupplies',
      'currentPageTVs',
    ]),
    ...mapGetters('page', [
      'canSell',
      'selectedPage',
      'linkbyLink',
    ]),
    displaySupplies() {
      const option = this.selectedSuppliesSortingOption;
      const arr = [...this.currentPageSupplies];

      if (option === '單價低') {
        arr.sort((a, b) => a.commodity.variants[0].sellingPrice - b.commodity.variants[0].sellingPrice);
      } else if (option === '單價高') {
        arr.sort((a, b) => b.commodity.variants[0].sellingPrice - a.commodity.variants[0].sellingPrice);
      } else if (option === '新品') {
        arr.sort((a, b) => new Date(b.commodity.createdAt) - new Date(a.commodity.createdAt));
      }

      return arr;
    },
    pagingDisplaySupplies() {
      return this.displaySupplies.slice(this.currentPage * 15, (this.currentPage + 1) * 15);
    },
  },
  async created() {
    if (!this.canSell) {
      this.$router.replace({ name: 'Appearance' });
    }
    const areSuppliesUpdated = await this.getSupplies();
    if (areSuppliesUpdated) {
      this.notify({
        message: '商品同步成功!',
        type: 'success',
      });
    }
    await this.getInstruction();
  },
  methods: {
    ...mapActions('sku', [
      'getSupplies',
      'dropSupply',
      'updateSupplyInfo',
      'getInstruction',
    ]),
    showSKUModal(sku) {
      this.sku = { ...sku };
      $('#manageSKUModal').modal('show');
    },
    showFilterSKUModal() {
      $('#filterSKUModal').modal('show');
    },
    selectSKU(sku) {
      const supplyID = sku._id;
      const i = this.supplies.findIndex((s) => s._id === supplyID);
      if (i > -1) {
        this.dropSupply({
          supplyIDs: [this.supplies[i]._id],
        }).then((response) => {
          if (response === 200) {
            this.notify({
              message: '商品刪除成功!',
              type: 'success',
            });
          } else {
            this.notify({
              message: '商品刪除失敗!',
              type: 'error',
            });
          }
          $('#manageSKUModal').modal('hide');
        });
      }
    },
    updateSKU({ supplyID, comment, youtubeUrl, youtubeTitle }) {
      const foundSupplyIndex = this.supplies.findIndex((s) => s._id === supplyID);
      if (foundSupplyIndex > -1) {
        this.updateSupplyInfo({ supplyID, comment, youtubeUrl, youtubeTitle }).then((response) => {
          if (response === 200) {
            this.notify({
              message: '商品更新成功!',
              type: 'success',
            });
            this.$refs.MissionMenu.updateComment();
          } else {
            this.notify({
              message: '商品更新失敗!',
              type: 'error',
            });
          }
          $('#manageSKUModal').modal('hide');
        });
      }
    },
    jumpTo(page) {
      this.currentPage = page;
      this.$scrollTo('#product-list', 400, { easing: 'ease-out' });
    },
    selectSortingOptions(option) {
      this.selectedSuppliesSortingOption = option;
    },
    notify(notification) {
      this.$emit('notify', notification);
    },
    preview() {
      $('#previewModal').modal('show');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/styles/setting'

.guide-info
  min-height: 120px
  padding-left: 20px
  background-color: $primary-100
  border-radius: 12px

  .title
    font-size: 18px
    span
      background: linear-gradient(to bottom, rgba(255,255,255,0) 30%, #adc1fc 30%, #adc1fc 80%, rgba(255,255,255,0) 80%)
  .description
    font: 14px

.sku
  &-list
    @media only screen and (min-width: 768px)
      border-radius: 3px
      border: solid 1px #d6e0fd
      background-color: #fff
      padding: 40px

  &-item
    padding: 12px 0
    @media only screen and (min-width: 768px)
      border-top: solid 1px #d6e0fd

  &-image-wrapper
    width: 66px
    height: 66px
    @media only screen and (min-width: 768px)
      width: 80px
      height: 80px

  &-description-title
    width: 66px
    @media only screen and (min-width: 768px)
      width: 80px

  &-image
    border-radius: 2px
    padding-bottom: 100%
  &-tv
    top: 5px
    right: 5px
    width: 24px
    height: 24px

    i
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
  &-description
    padding: 4px 0 4px 4px
    bottom: 0
    background-image: linear-gradient(to right, $primary 50%, rgba(255, 255, 255, 0.85))

  &-name
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 3
    overflow: hidden

.sharing-profit
  font-size: 12px
  border-radius: 4px
  white-space: nowrap

.status-box
  top: 3px
  right: 18px
  width: 24px
  height: 24px
  border-radius: 4px
  background-color: $primary

  &.selected
    background-color: $primary

  i
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

.btn-primary
  padding: 13px
</style>
